import { render } from "./ArticleGrid.vue?vue&type=template&id=57c046ee"
import script from "./ArticleGrid.vue?vue&type=script&lang=js"
export * from "./ArticleGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/article-grid/ArticleGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57c046ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57c046ee', __exports__)) {
    api.reload('57c046ee', __exports__)
  }
  
  module.hot.accept("./ArticleGrid.vue?vue&type=template&id=57c046ee", () => {
    api.rerender('57c046ee', render)
  })

}


export default __exports__